import Cookies from 'js-cookie';

const TokenKey = 'oss-token';
export function getSubdomain(hostname) {
  const parts = hostname.split('.');
  console.log(parts);
  if (parts.length > 2) {
    return `.${parts[1]}.${parts[2]}`;
  }
  return '';
}
const domain = getSubdomain(window.location.hostname);
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  console.log('setToken', token);
  return Cookies.set(TokenKey, token, { domain: domain });
}

export function removeToken() {
  return Cookies.remove(TokenKey, { domain: domain });
}

export function removeTokenOld() {
  return Cookies.remove(TokenKey);
}
